import FeaturedManufacturerRequests from '../../server/featuredManufacturer';
import { addLoading, removeLoading } from './loading';

const setFManufacturer = manufacturers => ({
  type: 'GET_FEATURED_MANUFACTURER',
  manufacturers,
});

const getFeaturedManufacturer = (limit, skip, search = '', order = '', field = '') => async (dispatch) => {
  dispatch(addLoading());
  try {
    const fManufacturer = await FeaturedManufacturerRequests.getFeaturedManufacturer(limit, skip, search, order, field);
    dispatch(setFManufacturer(fManufacturer));
  } finally {
    dispatch(removeLoading());
  }
};

const createFeaturedManufacturer = (categoryId, brandId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await FeaturedManufacturerRequests.createFeaturedManufacturer(categoryId, brandId);
  } finally {
    dispatch(removeLoading());
  }
};

const deleteFeaturedManufacturer = (categoryId, brandId) => async (dispatch) => {
  dispatch(addLoading());
  try {
    await FeaturedManufacturerRequests.deleteFeaturedManufacturer(categoryId, brandId);
  } finally {
    dispatch(removeLoading());
  }
};

export const getCsvFeaturedManufacturerModel = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await FeaturedManufacturerRequests.getCsvCategBrandModel();
  } finally {
    dispatch(removeLoading());
  }
};

const getCsvCategBrandsReport = () => async (dispatch) => {
  dispatch(addLoading());
  try {
    await FeaturedManufacturerRequests.getCsvCategBrandsReport();
  } finally {
    dispatch(removeLoading());
  }
};

export const uploadCategoriesBrands = file => async (dispatch) => {
  dispatch(addLoading());
  try {
    const result = await FeaturedManufacturerRequests.uploadCsvCategoriesBrands(file);
    return result;
  } finally {
    dispatch(removeLoading());
  }
};

export default {
  getFeaturedManufacturer,
  createFeaturedManufacturer,
  deleteFeaturedManufacturer,
  getCsvFeaturedManufacturerModel,
  getCsvCategBrandsReport,
};
